import console from "common/objects/console";

export default kendo.data.Binder.extend({
    applyRefresh: function(key, value) {
        console.log(key, value);
    },
    bindingName: "fieldName",

    init: function() {
        kendo.data.Binder.fn.init.apply(this, arguments);

        // get list of class names from our complex binding path object
        this._lookups = [];
        for (var key in this.bindings[this.bindingName].path) {
            this._lookups.push({
                key: key,
                path: this.bindings[this.bindingName].path[key]
            });
        }

        this.refresh();
    },

    refresh: function() {
        var lookup,
            value;

        for (var i = 0; i < this._lookups.length; i++) {
            lookup = this._lookups[i];

            // set the binder's path to the one for this lookup,
            // because this is what .get() acts on.
            this.bindings[this.bindingName].path = lookup.path;
            value = this.bindings[this.bindingName].get();

            this.applyRefresh(lookup.key, value);
        }
    }
});
